import React from 'react';
import PropTypes from 'prop-types';
import ProfileSelect from "./ProfileSelect";
import CustomerInfoEdit from "./CustomerInfoEdit";

class Title extends React.Component {
    static propTypes = {
        profile: PropTypes.object,
        profileList: PropTypes.array.isRequired,
        onProfileTitleChange: PropTypes.func.isRequired,
        onProfileCustomerInfoChange: PropTypes.func.isRequired,
    };

    render() {
        const {profileList, profile, onProfileCustomerInfoChange, onProfileTitleChange, className, ...props} = this.props;

        const info = profile ? Object.entries(profile.info.byCustomer).map(item => (item[1])).join(', ') : '';
        let classes = "conversation ";
        if (className) {
            classes += className;
        }

        return (
            <div className={classes} {...props}>
                <div className="conversation__from">
                    {profileList.length > 0 &&
                    <ProfileSelect profileList={profileList} profile={profile}/>
                    }
                </div>

                {profile &&
                <div className="conversation__to">
                    <strong className="text-lg text-primary">{profile.title}</strong><br/>
                    <CustomerInfoEdit advertName={profile.advert.name} id={profile.customer.customerLinks[0].ident}
                                      conversationTitle={profile.title} info={profile.info.byCustomer}
                                      onInfoChange={info => onProfileCustomerInfoChange(profile.id, info)}
                                      onTitleChange={title => onProfileTitleChange(profile.id, title)}/>
                    <span className="text-muted">
                        {info}
                    </span>
                </div>
                }
            </div>
        )
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Title/Title.jsx